import {IUITipoDePontuacao} from "./IUITipoDePontuacao";

export class UITipoDePontuacaoQtdSelos implements IUITipoDePontuacao {
  selosPorAtividade: number;
  empresa: any;

  constructor(empresa: any) {
    this.empresa = empresa;
  }

  calculePontuacao(pontuacaoResgistrada: any) {
    const plano = pontuacaoResgistrada.cartao?.plano;
    if (plano?.valorMinimoPontuar > 0 && pontuacaoResgistrada.valor < plano.valorMinimoPontuar)
      return 0;

    return this.selosPorAtividade * pontuacaoResgistrada.atividades.length;
  }
}
